import Button from "components/common/controls/Button";
import { useHistory } from "react-router-dom";
import * as routePath from "shared/constants/RoutePathConstants";
import { ControlSize } from "shared/enums/ControlSizeEnum";

interface Props {
  isPrimaryType?: boolean;
  size?: "normal" | "small";
}

export default function SignInButton({ isPrimaryType, size }: Props) {
  const history = useHistory();
  const handleSignInClick = () => {
    history.push(routePath.SIGN_IN);
  };
  return (
    <Button
      text="SIGN IN"
      onClick={handleSignInClick}
      {...(isPrimaryType
        ? {
            variant: "primary",
            radiusSize: ControlSize.Midium,
            className: "w-32",
          }
        : { variant: "secondary" })}
      textSizeClass={size === "small" ? "text-xs" : ""}
    />
  );
}
